define(function (require) {

    var _ = require('underscore');
    var Backbone = require("backbone");
    var Bubble = require("ui/bubble/Bubble");
    var lpAMSController = require('web-agent-assets-js/lpAMSController');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var BaseConnectionsListTableViewController = require('web-agent-viewControllers/BaseConnectionsListTableViewController');
    var AppConnectionsListWidgetsManager = require('web-agent-viewControllers/AppConnectionsListWidgetsManager');
    var AppConnectionsEngagementWidget = require('web-agent-widgets/AppConnectionsEngagementWidget');
    var ConsumerInfoWidget = require('web-agent-widgets/ConsumerInfoWidget');
    var FilterDropdownSelectionViewController = require('web-agent-components/FilterDropdownSelectionViewController');
    var ManagerParticipantsBubbleCollectionView = require("web-agent-views/ManagerParticipantsBubbleCollectionView");
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');

    var AppConnectionsListTableViewController = BaseConnectionsListTableViewController.extend({
        ControllerName: "AppConnectionsListTableViewController",
        applicationType: "AppConnectionsListTableViewController",

        LPViewMap: {
            tagItemMore: '.tag_item_more'
        },

        LPEventsMap: {
            mouseEnter: 'mouseenter',
            mouseLeave: 'mouseleave'
        },

        initialize: function (constructorData) {
            this.bubbleViewBoundEventsMap = {};
            this.logic = lpTag.WebAgent.logicController;
        },

        events: function () {
        },

        render: function () {
        }
    });

    AppConnectionsListTableViewController.prototype.getShowStatusOptions = function () {
        var options = BaseConnectionsListTableViewController.prototype.getShowStatusOptions.call(this);
        options.unshift(
            {
                id: lpAMSController.BADGES.IN_QUEUE,
                text: this.translate(this.translationTexts.connectionsStateFilterInQueue),
                icon: 'in_queue'
            }
        );

        return options;
    };


    AppConnectionsListTableViewController.prototype.getConfiguration = function () {
        var modelLocationName = lpAMSController.MODEL_PATHS.connectionsListModelLocations.modelLocationName;

        var configuration = {
            context: this,
            textsPrefix: this.LPPrefixMap.appConnectionsList,
            tableName: this.applicationType,
            tableRootModelPath: modelLocationName,
            globalData: {
                tableName: this.applicationType,
                textsPrefix: this.LPPrefixMap.appConnectionsList
            },
            tableHead: {
            },
            tableBody: {
                rowTemplateFile: 'LP_app_connections_list_row.html'
            },
            paging: {
                pageSize: this.getModelControllerInstance().getDefaultValue("limit"),
                hidePagingText: true
            },
            widgets: {
                widgetsManager: AppConnectionsListWidgetsManager,
                widgetsManagerData: {
                    className: "app_connections_widgets",
                    autoHideButtonsToolbar: false,
                    itemIdTag: "convId",
                    widgetsData: [
                        {
                            widgetType: AppConnectionsEngagementWidget,
                            widgetData: {
                                itemIdTag: "convId",
                                chatsRootModelPath: 'chats'
                            }
                        },
                        {
                            widgetType: ConsumerInfoWidget,
                            widgetData: {
                                visitorInfoPath: "consumerProfile",
                                chatIdPath: "convId"

                            }
                        }
                    ]
                }
            }
        };
        if (!lpTag.WebAgent.logicController.hasAgentGroupsColumn()) {
            configuration.tableHead.headerRowClassName += " hide_agentGroups";
        }
        return configuration;
    };

    AppConnectionsListTableViewController.prototype.getColumnsData = function () {
        //add agent name column if applicable
        var columnsData = BaseConnectionsListTableViewController.prototype.getColumnsData.call(this);
        var agentNameColumnIndex = _.findIndex(columnsData, {title: 'skill'}) + 1;
        columnsData.splice(agentNameColumnIndex, 0, {title: 'colAgentName'});
        //Add the agentData filter to the UI
        columnsData[agentNameColumnIndex].filter = {
            filterManager: FilterDropdownSelectionViewController,
            filterManagerData: {
                className: "filter_dropdown_selection_view",
                filterName: "agentIds",
                filterTextSuffix: "agents",
                filterDataModelPath: lpTag.WebAgent.logicController.needAllOperatorsDataList() ? "operators.all" : "operators.array",
                textProperty: "displayName",
                floating: false,
                toggleButton: lpTag.WebAgent.logicController.getOpenConnectionsFilterDeletedAgentsSiteSetting() && agentLEManager.getLEConfig().supportDeletedUsers && {
                    toggleByField: {
                        fieldName: 'deleted',
                        lineSubText: this.translate('filter_deleted_indication'),
                    },
                    checked: false
                },
                label: lpTag.WebAgent.logicController.getOpenConnectionsFilterDeletedAgentsSiteSetting() && agentLEManager.getLEConfig().supportDeletedUsers && this.translate('filter_deleted_agents_title')
            }
        };

        //Add the agentGroup column if it should be added or an empty one
        var columeConfiguration = {visitorImage: "visitorImage"};
        var agentGroupColumnIndex = _.findIndex(columnsData, {title: 'colAgentName'}) + 1;
        if (lpTag.WebAgent.logicController.hasAgentGroupsColumn()) {
            var isAgentGroupFilterActive = agentLEManager.getAccountSettingValueByIdLE('le.agent.messaging.showAgentGroupFilter') === 'true';
            columeConfiguration = {
                title: 'agentGroup'
            };
            if(isAgentGroupFilterActive) {
                columeConfiguration.filter = {
                    filterManager: FilterDropdownSelectionViewController,
                    filterManagerData: {
                        className: "filter_dropdown_selection_view",
                        filterName: "groupIds",
                        filterTextSuffix: "agentGroups",
                        filterDataModelPath: "agent.agentGroups.array",
                        textProperty: "displayName"
                    }
                };
            }
        }
        columnsData.splice(agentGroupColumnIndex, 0, columeConfiguration);
        return columnsData;
    };

    AppConnectionsListTableViewController.prototype.dataBinder = {
        modelDataChanged: BaseConnectionsListTableViewController.prototype.dataBinder.modelDataChanged,
        operationCanceled: BaseConnectionsListTableViewController.prototype.dataBinder.operationCanceled,
        rowSelected: BaseConnectionsListTableViewController.prototype.dataBinder.rowSelected,
        rowClicked: BaseConnectionsListTableViewController.prototype.dataBinder.rowClicked,
        rowChanged: function (data) {
            var tagItemView;
            data = data || {};
            if (data.view) {
                tagItemView = this.getFirstElement(this.LPViewMap.tagItemMore, data.view);
                if (tagItemView) {
                    bindManagerParticipantsBubble.call(this, tagItemView, data);
                }
            }
        }
    };

    AppConnectionsListTableViewController.prototype.dataRenderer = {
        numberOfSections: BaseConnectionsListTableViewController.prototype.dataRenderer.numberOfSections,
        numberOfRowsInSection: BaseConnectionsListTableViewController.prototype.dataRenderer.numberOfRowsInSection,
        dataForSection: BaseConnectionsListTableViewController.prototype.dataRenderer.dataForSection,
        dataForRowInSection: function (data, rowIndex, sectionIndex) {
            var value, conversationInfo, agentName, participationClassName, managerParticipantsCount,
                spectatedClassName, assignedAgentUnreadCount, managerParticipantsClassName, assignedAgentUnreadClassName, agentGroupName, agentGroupNameTooltip, agentDeleted, suggestedAgentClassName,agentProfile;

            value = BaseConnectionsListTableViewController.prototype.dataRenderer.dataForRowInSection.apply(this, arguments);
            conversationInfo = data[rowIndex];
            agentProfile = (conversationInfo && conversationInfo.assignedAgentProfile) || (conversationInfo && conversationInfo.suggestedAgentProfile);

            participationClassName = getParticipationClassName.call(this, conversationInfo);
            agentName = getAgentName.call(this, agentProfile);
            agentDeleted = getAgentDeleted.call(this, agentProfile);
            managerParticipantsCount = getManagerParticipantsCount.call(this, conversationInfo);
            assignedAgentUnreadCount = getAssignedAgentUnreadCount.call(this, conversationInfo);
            managerParticipantsClassName = getManagerParticipantsClassName.call(this, conversationInfo);
            spectatedClassName = getSpectatedClassName.call(this, conversationInfo);
            assignedAgentUnreadClassName = getAssignedAgentUnreadClassName.call(this, conversationInfo);
            agentGroupName = getAgentGroup.call(this, conversationInfo);
            suggestedAgentClassName = getSuggestedAgentClassName.call(this, conversationInfo);
            agentGroupNameTooltip = agentGroupName;

            value.participationClassName = participationClassName;
            value.agentNameValue = agentName;
            value.agentDeleted = agentDeleted ? this.translate('agent_deleted_indication') + ' ' : '';
            value.suggestedAgentClassName = suggestedAgentClassName;

            if (getAssignedAgentUnreadCount.call(this, conversationInfo)) {
                value.agentNameTooltip = this.translateObj('unreadMessagesByAssignedAgent', [{ key: assignedAgentUnreadCount }, { key: value.agentDeleted }, { key: agentName }]);
            }
            else {
                value.agentNameTooltip = value.agentDeleted + agentName;
            }

            if (suggestedAgentClassName) {
                value.agentNameTooltip = this.translate('transferredToAgent') +  value.agentNameTooltip;
            } else if (lpTag.WebAgent.logicController.hasTransferToAgentFeatureEnabled() && agentName !== this.translate('notAvailable')) {
                value.agentNameTooltip = this.translate('assignedToAgent') + value.agentNameTooltip;
            }
            // else- leave as assigned name or N/A

            value.managerParticipantsCount = managerParticipantsCount;
            value.managerParticipantsClassName = managerParticipantsClassName;
            value.spectatedClassName = spectatedClassName;
            value.assignedAgentUnreadCount = assignedAgentUnreadCount;
            value.assignedAgentUnreadClassName = assignedAgentUnreadClassName;
            value.agentGroupName = agentGroupName;
            value.agentGroupNameTooltip = agentGroupNameTooltip;
            if (!lpTag.WebAgent.logicController.hasAgentGroupsColumn()) {
                value.className += " hide_agentGroups";
            }
            return value;
        }
    };

    AppConnectionsListTableViewController.prototype.getModelControllerInstance = function () {
        return lpTag.WebAgent.appConnectionListController;
    };

    function getSuggestedAgentClassName(conversationInfo) {
        return !!conversationInfo.suggestedAgentId ? 'suggested_agent' : '';
    }

    function getAssignedAgentUnreadCount(conversationInfo) {
        if (lpTag.WebAgent.logicController.isSpectatedEngagementByChatId(conversationInfo.convId)) {
            return conversationInfo.assignedAgentUnreadCount;
        }
        return 0;
    }

    function getManagerParticipantsCount(conversationInfo) {
        return conversationInfo.managerParticipantsCount;
    }

    function getManagerParticipantsClassName(conversationInfo) {
        return conversationInfo.managerParticipantsCount ? '' : 'hide';
    }

    function getAssignedAgentUnreadClassName(conversationInfo) {
        return getAssignedAgentUnreadCount.call(this, conversationInfo) ? 'unread_icon' : 'hide';
    }

    function getAgentGroup (conversationInfo) {
        return lpTag.WebAgent.logicController.getAgentGroup(conversationInfo && conversationInfo.agentGroupId);
    }

    function getSpectatedClassName(conversationInfo) {
        var className,
            isSpectatedEngagement = this.logic.isSpectatedEngagementByChatId(conversationInfo.convId);
        if (isSpectatedEngagement) {
            className = 'spectated';
        } else {
            className = '';
        }
        return className;
    }

    function getParticipationClassName(conversationInfo) {
        var classNames = [],
            conversationId = conversationInfo.convId,
            dialogId = this.logic.getActiveDialogIdOfConversation(conversationId),
            participantsRoles = this.logic.participantsRoles,
            role = this.logic.getLoggedInAgentRoleInConversationDialog(conversationId, dialogId),
            isLoggedInAgentPeekerParticipant = this.logic.isLoggedInAgentPeekerParticipant(conversationId, dialogId);

        if (role !== participantsRoles.ASSIGNED_AGENT && !isLoggedInAgentPeekerParticipant) {
            if (role === participantsRoles.MANAGER) {
                classNames.push('participate_icon');
                classNames.push('manager');
            }
            else if (role === participantsRoles.READER) {
                classNames.push('participate_icon');
                classNames.push('reader');
            }
        } else {
            classNames.push('hide');
        }
        return classNames.join(' ');
    }

    function getAgentDeleted(agentProfile) {

        return agentProfile && agentProfile.isDeleted;
    }

    function getAgentName(agentProfile) {

        return agentProfile && agentProfile.fullName || this.translate('notAvailable');
    }

    function bindManagerParticipantsBubble(element, rowChangeData) {
        var rowBoundBubbleViewEvent,
            mouseEnterEventRequest,
            mouseLeaveEventRequest;

        rowBoundBubbleViewEvent = this.bubbleViewBoundEventsMap[rowChangeData.id];
        if (!_.isEmpty(rowBoundBubbleViewEvent)) {
            this.unbindViewEvent(rowBoundBubbleViewEvent[this.LPEventsMap.mouseEnter]);
            this.unbindViewEvent(rowBoundBubbleViewEvent[this.LPEventsMap.mouseLeave]);
            delete this.bubbleViewBoundEventsMap[rowChangeData.id];
        }

        mouseEnterEventRequest = createBubbleMouseEnterEventRequest.call(this, element, rowChangeData);
        mouseLeaveEventRequest = createBubbleMouseLeaveEventRequest.call(this, element);

        this.bubbleViewBoundEventsMap[rowChangeData.id] = {};
        this.bubbleViewBoundEventsMap[rowChangeData.id][this.LPEventsMap.mouseEnter] = mouseEnterEventRequest;
        this.bubbleViewBoundEventsMap[rowChangeData.id][this.LPEventsMap.mouseLeave] = mouseLeaveEventRequest;

        this.bindViewEvent(mouseEnterEventRequest);
        this.bindViewEvent(mouseLeaveEventRequest);
    }

    function createBubbleMouseEnterEventRequest(element, rowChangeData) {
        return {
            view: element,
            DOMEvent: this.LPEventsMap.mouseEnter,
            callback: showBubble,
            context: this,
            lpEventData: {
                unreadCountElement: element,
                managerParticipantsUnreadData: rowChangeData.rowData.managerParticipantsUnreadData
            }
        };
    }

    function createBubbleMouseLeaveEventRequest(element) {
        return {
            view: element,
            DOMEvent: this.LPEventsMap.mouseLeave,
            callback: hideBubble,
            context: this
        };
    }

    function showBubble(e) {
        var eventData;
        if (!this.bubbleComponent) {
            eventData = e.lpEventData || {};
            createAndRenderBubble.call(this, eventData);
        }
    }

    function hideBubble() {
        if (this.bubbleComponent) {
            this.bubbleComponent.close(true);
            delete this.bubbleComponent;
        }
    }

    function createAndRenderBubble(eventData) {
        this.bubbleComponent = new Bubble({
            containerSelector: '.web-agent-wrapper',
            targetControl: eventData.unreadCountElement,
            contentView: new ManagerParticipantsBubbleCollectionView({
                collection: new Backbone.Collection(eventData.managerParticipantsUnreadData)
            }),
            position: Bubble.POSITION.BOTTOM,
            isDelayed: true
        });
        this.bubbleComponent.render();
    }

    window.AppConnectionsListTableViewController = AppConnectionsListTableViewController;


    return AppConnectionsListTableViewController;

});
